// extracted by mini-css-extract-plugin
module.exports = {"banner":"versionBanner_banner__IDxgi"};